import type { RowData } from '@tanstack/react-table'

import { Checkbox } from '@/components'
import type { Table } from '@/components/ui/table/types'

interface TableSelectAllCheckboxProps<TData extends RowData> {
  table: Table<TData>
}

// Check "all" first: getIsSomePageRowsSelected is also true when every row is selected.
export const TableSelectAllCheckbox = <TData extends RowData>({
  table,
}: TableSelectAllCheckboxProps<TData>) => (
  <Checkbox
    checked={
      table.getIsAllPageRowsSelected() ||
      (table.getIsSomePageRowsSelected() && 'indeterminate')
    }
    onCheckedChange={(value: boolean) =>
      table.toggleAllPageRowsSelected(!!value)
    }
    aria-label="Select all"
  />
)

interface TableSelectRowCheckboxProps {
  row: {
    getIsSelected: () => boolean
    getCanSelect: () => boolean
    toggleSelected: (value: boolean) => void
  }
}

export const TableSelectRowCheckbox = ({
  row,
}: TableSelectRowCheckboxProps) => {
  if (!row.getCanSelect()) return null
  return (
    // Keep a select click from also toggling an expandable row underneath it.
    <span
      className="flex items-center"
      onClick={(event) => event.stopPropagation()}
    >
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value: boolean) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    </span>
  )
}
